import React from 'react'
import { Outlet } from 'react-router-dom'

function MainTickets() {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default MainTickets
